export const pmTheme = {
  surface: 'hsl(var(--card))',
  surfaceSubtle: 'hsl(var(--muted) / 0.18)',
  surfaceMuted: 'hsl(var(--muted) / 0.35)',
  surfaceHover: 'hsl(var(--muted) / 0.45)',
  surfaceAccent: 'hsl(var(--primary) / 0.12)',
  surfaceSuccess: 'hsl(var(--feedback-success-bg))',
  surfaceDanger: 'hsl(var(--feedback-error-bg))',
  text: 'hsl(var(--card-foreground))',
  textMuted: 'hsl(var(--muted-foreground))',
  textSubtle: 'hsl(var(--muted-foreground) / 0.75)',
  textInverse: 'hsl(var(--primary-foreground))',
  border: 'hsl(var(--border))',
  borderSubtle: 'hsl(var(--border) / 0.6)',
  input: 'hsl(var(--input))',
  primary: 'hsl(var(--primary))',
  primarySoft: 'hsl(var(--primary) / 0.12)',
  primaryBorder: 'hsl(var(--primary) / 0.35)',
  success: 'hsl(var(--feedback-success))',
  successSoft: 'hsl(var(--feedback-success-bg))',
  successBorder: 'hsl(var(--border-success) / 0.55)',
  warning: 'hsl(var(--feedback-warning))',
  warningSoft: 'hsl(var(--feedback-warning-bg))',
  danger: 'hsl(var(--destructive))',
  dangerSoft: 'hsl(var(--feedback-error-bg))',
  dangerBorder: 'hsl(var(--border-error) / 0.55)',
  shadow: 'var(--shadow-sm)',
};

export type PMTheme = typeof pmTheme;
